import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import AboutPage from "@/pages/o-mnie/page";
import OfferPage from "@/pages/oferta/page";
import DlaFirmPage from "@/pages/dla-firm/page";
import JakDzialamPage from "@/pages/jak-dzialam/page";
import FaqPage from "@/pages/faq/page";
import AnalizaPage from "@/pages/analiza/page";
import KontaktPage from "@/pages/kontakt/page";
import Doradca360Page from "@/pages/doradca360/page";
import NarzedziaPage from "@/pages/narzedzia/page";
import NadplataPage from "@/pages/narzedzia/nadplata-kredytu/page";
import RefinansowaniePage from "@/pages/narzedzia/refinansowanie/page";
import ZdolnoscPage from "@/pages/narzedzia/zdolnosc-kredytowa/page";
import PolitykaPrywatnosciPage from "@/pages/polityka-prywatnosci/page";
import KredytFirmowyPage from "@/pages/narzedzia/kredyt-firmowy/page";
import LeasingVsKredytPage from "@/pages/narzedzia/leasing-vs-kredyt/page";
import KonsolidacjaPage from "@/pages/narzedzia/konsolidacja/page";
import BlogPage from "@/pages/blog/page";
import ArticlePage from "@/pages/blog/ArticlePage";
import ServiceLandingPage from "@/pages/uslugi/ServiceLandingPage";
import RodoPage from "@/pages/rodo/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/o-mnie",
    element: <AboutPage />,
  },
  {
    path: "/oferta",
    element: <OfferPage />,
  },
  {
    path: "/dla-firm",
    element: <DlaFirmPage />,
  },
  {
    path: "/jak-dzialam",
    element: <JakDzialamPage />,
  },
  {
    path: "/analiza",
    element: <AnalizaPage />,
  },
  {
    path: "/narzedzia",
    element: <NarzedziaPage />,
  },
  {
    path: "/narzedzia/nadplata-kredytu",
    element: <NadplataPage />,
  },
  {
    path: "/narzedzia/refinansowanie",
    element: <RefinansowaniePage />,
  },
  {
    path: "/narzedzia/zdolnosc-kredytowa",
    element: <ZdolnoscPage />,
  },
  {
    path: "/narzedzia/kredyt-firmowy",
    element: <KredytFirmowyPage />,
  },
  {
    path: "/narzedzia/leasing-vs-kredyt",
    element: <LeasingVsKredytPage />,
  },
  {
    path: "/narzedzia/konsolidacja",
    element: <KonsolidacjaPage />,
  },
  {
    path: "/doradca360",
    element: <Doradca360Page />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <ArticlePage />,
  },
  { path: "/kredyt-hipoteczny-sanok", element: <ServiceLandingPage /> },
  { path: "/kredyt-gotowkowy-sanok", element: <ServiceLandingPage /> },
  { path: "/kredyt-firmowy-sanok", element: <ServiceLandingPage /> },
  { path: "/refinansowanie-kredytu-sanok", element: <ServiceLandingPage /> },
  {
    path: "/kontakt",
    element: <KontaktPage />,
  },
  {
    path: "/polityka-prywatnosci",
    element: <PolitykaPrywatnosciPage />,
  },
  {
    path: "/rodo",
    element: <RodoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
